import React, { forwardRef, MouseEventHandler, useState } from "react";
import ModalForm from "./ModalForm";

export interface Props {
	id?: string;
	className?: string;
	disabled?: boolean;
	title?: string;
	confirmLabel?: string;
	cancelLabel?: string;
	disableConfirm?: boolean;
	onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
	onConfirm: () => void;
	onCancel?: () => void;
	form?: React.ReactNode;
	children: React.ReactNode;
}

export const ButtonWithForm = forwardRef<HTMLButtonElement, Props>((props, ref) => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		props.onClick && props.onClick(event);
		setIsDialogOpen(true);
	};
	const handleConfirm = () => {
		setIsDialogOpen(false);
		props.onConfirm();
	};
	const handleCancel = () => {
		setIsDialogOpen(false);
		if (props.onCancel) props.onCancel();
	};

	return (
		<>
			<button
				id={props.id}
				ref={ref}
				className={props.className ?? "btn btn-neutral"}
				onClick={handleClick}
				disabled={props.disabled}>
				{props.children}
			</button>

			{isDialogOpen && (
				<ModalForm
					open={isDialogOpen}
					title={props.title}
					form={props.form}
					confirmLabel={props.confirmLabel ?? "OK"}
					cancelLabel={props.cancelLabel ?? "Cancel"}
					disableConfirm={props.disableConfirm ?? false}
					onConfirm={handleConfirm}
					onCancel={handleCancel}
				/>
			)}
		</>
	);
});

export default ButtonWithForm;
